<template>
  <v-app style="background-color: #f8f9fb">
    <v-container>
      <v-col cols="12">
        <v-card elevation="0" class="px-5 py-3">
          <div class="d-flex align-center justify-space-between flex-wrap" style="gap: 12px">
            <v-card-title class="px-0 py-0">Carnê digital</v-card-title>
            <div class="d-flex align-center" style="gap: 8px">
              <v-text-field
                v-model="filtro"
                label="Buscar contrato, resposta, IP..."
                dense
                solo-inverted
                hide-details
                clearable
                style="min-width: 260px"
                prepend-inner-icon="mdi-magnify"
              ></v-text-field>
              <v-btn
                color="#4682B4"
                height="40"
                :loading="carregando"
                @click="carregar"
              >
                Atualizar
                <v-icon right dark>mdi-refresh</v-icon>
              </v-btn>
              <v-btn
                color="success"
                height="40"
                :disabled="!itensFiltrados.length"
                :loading="exportando"
                @click="exportarExcel"
              >
                Excel
                <v-icon right dark>mdi-file-excel</v-icon>
              </v-btn>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-container>

    <v-container style="background-color: #eee" fluid tag="section">
      <v-alert v-if="mensagem" type="error" dense class="mb-4">
        {{ mensagem }}
      </v-alert>

      <v-card elevation="0" class="pa-4">
        <v-data-table
          :headers="headers"
          :items="itensFiltrados"
          :loading="carregando"
          :items-per-page="15"
          class="elevation-0"
        >
          <template v-slot:item.data_hora="{ item }">
            {{ formatarData(item.data_hora) }}
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </v-app>
</template>

<script>
import * as XLSX from "xlsx";
import CarneDigitalService from "@/services/carneDigital";

export default {
  name: "CarneDigital",
  data: () => ({
    itens: [],
    filtro: "",
    carregando: false,
    exportando: false,
    mensagem: "",
    headers: [
      { text: "ID", value: "id" },
      { text: "Contrato", value: "contrato" },
      { text: "Resposta", value: "resposta" },
      { text: "Data/Hora", value: "data_hora" },
      { text: "IP", value: "ip" },
      { text: "Plataforma", value: "plataforma" },
      { text: "Código", value: "codigo" },
      { text: "Chave", value: "chave" },
    ],
  }),
  computed: {
    itensFiltrados() {
      const termo = (this.filtro || "").trim().toLowerCase();
      if (!termo) return this.itens;
      return this.itens.filter((item) =>
        [
          item.id,
          item.contrato,
          item.resposta,
          item.ip,
          item.plataforma,
          item.codigo,
          item.chave,
        ]
          .filter((v) => v != null)
          .some((v) => String(v).toLowerCase().includes(termo))
      );
    },
  },
  mounted() {
    this.carregar();
  },
  methods: {
    formatarData(valor) {
      if (!valor) return "";
      const d = new Date(valor);
      if (Number.isNaN(d.getTime())) return String(valor);
      return d.toLocaleString("pt-BR");
    },
    async carregar() {
      this.carregando = true;
      this.mensagem = "";
      try {
        const response = await CarneDigitalService.listar();
        this.itens = Array.isArray(response.data) ? response.data : [];
      } catch (e) {
        this.itens = [];
        this.mensagem =
          "Não foi possível carregar a listagem do carnê digital.";
        console.error(e);
      } finally {
        this.carregando = false;
      }
    },
    exportarExcel() {
      if (!this.itensFiltrados.length) return;
      this.exportando = true;
      try {
        const rows = this.itensFiltrados.map((item) => ({
          ID: item.id,
          Contrato: item.contrato,
          Resposta: item.resposta,
          "Data/Hora": this.formatarData(item.data_hora),
          IP: item.ip,
          Plataforma: item.plataforma,
          Código: item.codigo,
          Chave: item.chave,
        }));
        const worksheet = XLSX.utils.json_to_sheet(rows);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Carne digital");
        XLSX.writeFile(workbook, `carne_digital_${Date.now()}.xlsx`);
      } catch (e) {
        this.mensagem = "Erro ao gerar o Excel.";
        console.error(e);
      } finally {
        this.exportando = false;
      }
    },
  },
};
</script>
